import React from 'react'
import { ItemAttribute } from '../../../../types/interfaces'
import { valueTypeToInputType } from '../../../../utils/functions/enumToText'
import { Toggle } from '../../../toggle/Toggle'
import { v4 } from 'uuid'
import classes from './DynamicToggle.module.sass'

type Props = {
  el: ItemAttribute
  onChange: (id: string, value: string | string[] | boolean) => void
}

export const DynamicToggle = ({ el, onChange }: Props) => {
  return (
    <div className={classes.container}>
      <Toggle
        id={`${el.id}_${v4()}`}
        onChange={() => onChange(String(el.id), !el.value)}
        checked={el.value === true ? true : false}
      />
      <div className={classes.label}>{el.name}</div>
    </div>
  )
}
